import { render, staticRenderFns } from "./price-chart.vue?vue&type=template&id=ad67faa8"
import script from "./price-chart.vue?vue&type=script&lang=js"
export * from "./price-chart.vue?vue&type=script&lang=js"
import style0 from "./price-chart.vue?vue&type=style&index=0&id=ad67faa8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports